import React from 'react';
import './App.css';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import EnquiryForm from './components/EnquiryForm';
import Footer from './components/Footer';
import Navigation from './components/Navigation';

function App() {
  return (
    <div className="App">
      <Navigation />
      <Hero />
      <Services />
      <About />
      <EnquiryForm />
      <Footer />
    </div>
  );
}

export default App;
